import React from 'react';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Text,
} from '@chakra-ui/react';
import { SdgItemWithIndicators } from './SdgItemWithIndicators';

type IndicatorsAccordionProps = {
  sdgNumber: number;
};

export const IndicatorsAccordion = ({
  sdgNumber,
}: IndicatorsAccordionProps) => (
  <Accordion
    allowMultiple
    maxW="28rem"
    w="100%"
    display="flex"
    justifyContent="center"
  >
    <AccordionItem display="flex" flexDir="column" alignItems="center">
      <AccordionButton w="fit-content">
        <Text flex="1" textAlign="left" fontSize="sm">
          Data that will be required from your institution
        </Text>

        <AccordionIcon />
      </AccordionButton>

      <AccordionPanel>
        <SdgItemWithIndicators sdgNumber={sdgNumber} />
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
);
